if (!customElements.get('akuma-banner')) {
  customElements.define('akuma-banner', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      this.track = this.querySelector('.akuma-banner__track');
      this.slides = [...this.querySelectorAll('.akuma-banner__slide')];
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches || this.dataset.autoplay !== 'true';
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.hidden = this.slides.length < 2;
        button.addEventListener('click', () => { this.stopAutoplay(); this.go(this.index + Number(button.dataset.direction)); }, options);
      });
      if (this.pauseButton) {
        this.pauseButton.hidden = this.slides.length < 2 || this.dataset.autoplay !== 'true';
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); }, options);
      }
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateSlides());
      }, { ...options, passive:true });
      this.track.addEventListener('pointerdown', () => this.stopAutoplay(), options);
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.stopAutoplay(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.addEventListener('focusin', event => { if (event.target !== this.pauseButton) this.stopAutoplay(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.stopAutoplay(); this.go(index, false); }
      }, options);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && !document.hidden && !this.reduced.matches) this.go(this.index + 1);
      }, Math.min(10, Math.max(1, Number(this.dataset.interval) || 5)) * 1000);
      this.resize = new ResizeObserver(() => { this.go(this.index, false); this.headerLayout(); });
      this.resize.observe(this.track);
      this.header = document.querySelector('.section-header');
      if (this.header) this.resize.observe(this.header);
      window.addEventListener('scroll', () => this.updateHeader(), { ...options, passive:true });
      document.addEventListener('shopify:section:reorder', () => this.headerLayout(), options);
      this.updateSlides(); this.updatePause(); this.headerLayout();
    }
    go(index, smooth = true) {
      if (!this.slides.length) return;
      const target = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left:target * this.track.clientWidth, behavior:smooth && !this.reduced.matches ? 'smooth' : 'instant' });
    }
    updateSlides() {
      this.index = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
      this.slides.forEach((slide, i) => { slide.inert = i !== this.index; slide.setAttribute('aria-hidden', String(i !== this.index)); });
      this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    stopAutoplay() { this.paused = true; this.updatePause(); }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
    }
    headerLayout() {
      const section = this.closest('.shopify-section');
      const first = document.querySelector('#MainContent > .shopify-section');
      const eligible = !!this.header && section === first && this.dataset.overlay === 'true';
      section?.classList.toggle('akuma-banner-under-header', eligible);
      if (eligible) {
        this.ownsHeader = true;
        document.documentElement.classList.add('akuma-banner-header');
        document.documentElement.style.setProperty('--akuma-banner-header-height', `${this.header.offsetHeight}px`);
        this.updateHeader();
      } else if (this.ownsHeader) this.clearHeader();
    }
    updateHeader() { if (this.ownsHeader) document.documentElement.classList.toggle('akuma-banner-scrolled', window.scrollY > 4); }
    clearHeader() { this.ownsHeader = false; document.documentElement.classList.remove('akuma-banner-header', 'akuma-banner-scrolled'); document.documentElement.style.removeProperty('--akuma-banner-header-height'); }
    disconnectedCallback() { this.abort?.abort(); clearInterval(this.timer); cancelAnimationFrame(this.frame); this.resize?.disconnect(); if (this.ownsHeader) this.clearHeader(); }
  });
}
